'use client';

import useReceiveAuthBC from '../auth/useReceiveAuthBC';
function ReceiveAuthBC() {
  useReceiveAuthBC();
  return null;
}
export default ReceiveAuthBC;